import { render, staticRenderFns } from "./couponMarketplace.vue?vue&type=template&id=6dafdba4&"
import script from "./couponMarketplace.vue?vue&type=script&lang=js&"
export * from "./couponMarketplace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6dafdba4')) {
      api.createRecord('6dafdba4', component.options)
    } else {
      api.reload('6dafdba4', component.options)
    }
    module.hot.accept("./couponMarketplace.vue?vue&type=template&id=6dafdba4&", function () {
      api.rerender('6dafdba4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmTool/couponMarketplace/couponMarketplace.vue"
export default component.exports